// Fix for Keeper Security extension errors and browser extension communication errors
// This prevents console spam from extension errors

if (typeof window !== 'undefined') {
  // Override console.error and console.warn to suppress extension-related errors
  const originalConsoleError = console.error;
  const originalConsoleWarn = console.warn;
  
  const shouldSuppress = (...args) => {
    // Check all arguments for extension-related error patterns
    const allMessages = args.map(arg => {
      if (typeof arg === 'string') return arg;
      if (arg?.message) return arg.message.toString();
      if (arg?.stack) return arg.stack.toString();
      return arg?.toString() || '';
    }).join(' ').toLowerCase();
    
    // Check if error is from extension file
    const isExtensionFile = allMessages.includes('6.js') || 
                           allMessages.includes('bg.js') ||
                           allMessages.includes('chrome-extension://') ||
                           allMessages.includes('moz-extension://') ||
                           allMessages.includes('safari-extension://');
    
    const errorPatterns = [
      'settingnametotoggle',
      'cannot read properties of undefined',
      'cannot read properties of null',
      'reading \'dataset\'',
      'reading "dataset"',
      'could not establish connection',
      'receiving end does not exist',
      'message channel closed',
      'moved into back/forward cache',
      'back/forward cache',
      'page keeping the extension port',
      'a listener indicated an asynchronous response',
      'bg.js',
      'chrome-extension://',
      'moz-extension://',
      'safari-extension://',
      'unchecked runtime.lasterror',
      'runtime.lasterror',
      'runtime.lastError',
      'error in event handler',
      'extension context invalidated',
      'message port closed',
      'extension port',
      'message channel closed before a response was received'
    ];
    
    return isExtensionFile || errorPatterns.some(pattern => allMessages.includes(pattern));
  };
  
  console.error = (...args) => {
    if (shouldSuppress(...args)) {
      return;
    }
    originalConsoleError.apply(console, args);
  };
  
  console.warn = (...args) => {
    if (shouldSuppress(...args)) {
      return;
    }
    originalConsoleWarn.apply(console, args);
  };

  // Add a global error handler for unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    // Handle different error object formats
    const errorMessage = event.reason?.message?.toString() || '';
    const errorSource = event.reason?.stack?.toString() || '';
    const errorString = event.reason?.toString() || '';
    const errorFileName = event.reason?.fileName || '';
    const errorName = event.reason?.name || '';
    
    // Combine all error info for pattern matching
    const combinedMessage = (
      errorMessage + ' ' + 
      errorSource + ' ' + 
      errorString + ' ' + 
      errorFileName + ' ' +
      errorName
    ).toLowerCase();
    
    // Check if error is from extension file
    const isExtensionError = (
      errorFileName?.includes('chrome-extension://') || 
      errorFileName?.includes('moz-extension://') ||
      errorFileName?.includes('safari-extension://') ||
      errorSource?.includes('chrome-extension://') ||
      errorSource?.includes('BG.js') ||
      errorSource?.includes('6.js')
    );
    
    const errorPatterns = [
      'settingnametotoggle',
      'cannot read properties of undefined',
      'cannot read properties of null',
      'reading \'dataset\'',
      'reading "dataset"',
      'could not establish connection',
      'receiving end does not exist',
      'message channel closed',
      'moved into back/forward cache',
      'back/forward cache',
      'page keeping the extension port',
      'extension port',
      'a listener indicated an asynchronous response',
      'message channel closed before a response was received',
      'bg.js',
      '6.js',
      'chrome-extension://',
      'moz-extension://',
      'safari-extension://',
      'runtime.lasterror',
      'runtime.lastError',
      'unchecked runtime.lasterror',
      'unchecked runtime.lastError',
      'extension context invalidated',
      'message port closed',
      'error in event handler'
    ];
    
    if (isExtensionError || errorPatterns.some(pattern => combinedMessage.includes(pattern))) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  }, true); // Use capture phase to catch early

  // Add error handler for regular errors
  window.addEventListener('error', (event) => {
    const errorMessage = event.error?.message?.toString() || '';
    const errorSource = event.error?.stack?.toString() || '';
    const errorString = event.error?.toString() || '';
    const errorFileName = event.filename || '';
    const combinedMessage = (errorMessage + ' ' + errorSource + ' ' + errorString + ' ' + errorFileName).toLowerCase();
    
    // Check if the error is from a chrome extension file (including 6.js which is common)
    const isExtensionError = errorFileName && (
      errorFileName.includes('chrome-extension://') || 
      errorFileName.includes('moz-extension://') ||
      errorFileName.includes('safari-extension://') ||
      errorFileName.includes('6.js') ||
      errorFileName.includes('/javascript/')
    );
    
    const errorPatterns = [
      'settingnametotoggle',
      'cannot read properties of undefined',
      'cannot read properties of null',
      'reading \'dataset\'',
      'reading "dataset"',
      'could not establish connection',
      'receiving end does not exist',
      'message channel closed',
      'moved into back/forward cache',
      'back/forward cache',
      'page keeping the extension port',
      'extension port',
      'a listener indicated an asynchronous response',
      'message channel closed before a response was received',
      'bg.js',
      '6.js',
      'chrome-extension://',
      'moz-extension://',
      'safari-extension://',
      'runtime.lasterror',
      'runtime.lastError',
      'unchecked runtime.lasterror',
      'unchecked runtime.lastError',
      'extension context invalidated',
      'message port closed',
      'error in event handler'
    ];
    
    if (isExtensionError || errorPatterns.some(pattern => combinedMessage.includes(pattern))) {
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
  }, true); // Use capture phase to catch early
}